import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "./_metronic/layout";
import { DashboardPage } from "./components/Dashboard/DashboardPage";
import { MarketingPage } from "./components/MangeMarketingMaterial/MarketingPage";
import { BannerEdit } from "./components/MangeMarketingMaterial/marketing-add-edit/BannerEditAdd";
import { CategoriesPage } from "./components/ManageCategory/CategoriesPage";
import { CategoryEdit } from "./components/ManageCategory/category-add-edit/CategoryEditAdd";
import Help from "./components/Help/Help";
import Setting from "./components/Setting/Setting";
import ProductSync from "./components/ProductSync/ProductSync";
import { MerchantPage } from "./components/ManageMerchants/MerchantPage";
import { MerchantEdit } from "./components/ManageMerchants/merchant-add-edit/MerchantEditAdd";
import { Test } from "./components/Test/Test";
import { PricePage } from "./components/ManagePricing/PricePage";
import { PriceEdit } from "./components/ManagePricing/price-add-edit/PriceEditAdd";
import { WocommercePricePage } from "./components/ManageWocommercePricing/WocommercePricePage";
import { WocommercePriceEdit } from "./components/ManageWocommercePricing/wocommerce-price-add-edit/WocommercePriceEditAdd";
import { CartPricePage } from "./components/ManageCartPricing/CartPricePage";
import { CartPriceEdit } from "./components/ManageCartPricing/cart-price-add-edit/CartPriceEditAdd";
import { WixPricePage } from "./components/ManageWixPricing/WixPricePage";
import { WixPriceEdit } from "./components/ManageWixPricing/wix-price-add-edit/WixPriceEditAdd";
import MainSetting from "./components/Setting/MainSetting";
import { WixCategoriesPage } from "./components/ManageWixCategory/WixCategoriesPage";
import { WixCategoryEdit } from "./components/ManageWixCategory/wix-category-add-edit/CategoryEditAdd";
import { WocommCategoriesPage } from "./components/ManageWoCommCategory/WocommCategoriesPage";
import { WocommCategoryEdit } from "./components/ManageWoCommCategory/wocomm-category-add-edit/CategoryEditAdd";
import Actiivity from "./components/ManageActivities/Activity";
import { ActivityPage } from "./components/ManageActivities/ActivityPage";
import { CategoryViewDialog } from "./components/ManageWixCategory/wix-category-table/category-dialogue/CategoryViewDialogue";
import { WoCommCategoryViewDialog } from "./components/ManageWoCommCategory/category-dialogue/WoCommCategoryViewDialogue";
import SmtpPage from "./components/Setting/SmtpPage";
import { MerchantView } from "./components/ManageMerchants/marchant-dialog/MerchantViewDialog";
import { PortalMerchantEdit } from "./components/ManageMerchants/merchant-add-edit/PortalMerchantEditAdd";
const UserProfilepage = lazy(() =>
  import("./components/UserProfile/UserProfilePage")
);

export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }

        {/* users management */}
        <ContentRoute path="/dashboard" component={DashboardPage} />

        {/* marketing material */}
        <ContentRoute path="/marketing" component={MarketingPage} />
        <ContentRoute path="/app/marketing/new" component={BannerEdit} />
        <ContentRoute path="/app/marketing/:id/edit" component={BannerEdit} />

        {/*categories */}
        <ContentRoute path="/category" component={CategoriesPage} />
        <ContentRoute path="/app/categories/new" component={CategoryEdit} />
        <ContentRoute path="/app/categories/:id/:total/edit" component={CategoryEdit} />

        {/*categories */}
        <ContentRoute path="/merchants" component={MerchantPage} />
        <ContentRoute path="/app/merchant/new" component={MerchantEdit} />
        <ContentRoute path="/app/merchant/:type/:id/edit" component={MerchantEdit} />
        <ContentRoute path = "/app/merchant/:type/:id/view" component={MerchantView}/>
        <ContentRoute path = "/app/portal/merchant/new" component={PortalMerchantEdit}/>
        <ContentRoute path = "/app/portal/merchant/:id/edit" component={PortalMerchantEdit}/>

        {/*help */}
        <ContentRoute path="/help" component={Help} />

        {/*setting */}
        <ContentRoute path="/setting" component={Setting} />
        <ContentRoute path="/smtp-settings" component={SmtpPage}/>

         {/*setting */}
         <ContentRoute path="/main-setting" component={MainSetting} />

        {/*test */}
        <ContentRoute path="/test" component={Test} />

        {/*productsync */}
        <ContentRoute path="/product-sync" component={ProductSync} />

        {/* shopify price */}
        <ContentRoute path="/shopify-price" component={PricePage} />
        <ContentRoute path="/app/shopify-price/new" component={PriceEdit} />
        <ContentRoute path="/app/shopify-price/:id/edit" component={PriceEdit} />

        {/*wix price */}
        <ContentRoute path="/wix-price" component={WixPricePage} />
        <ContentRoute path="/app/wix-price/new" component={WixPriceEdit} />
        <ContentRoute path="/app/wix-price/:id/edit" component={WixPriceEdit} />

        {/*wocommerce price */}
        <ContentRoute path="/wocommerce-price" component={WocommercePricePage} />
        <ContentRoute path="/app/wocommerceprice/new" component={WocommercePriceEdit} />
        <ContentRoute path="/app/wocommerceprice/:id/edit" component={WocommercePriceEdit} />
        <ContentRoute path="/app/woocommerce-categories/:id/view" component={WoCommCategoryViewDialog}/>

        {/*cart price */}
        <ContentRoute path="/cart-price" component={CartPricePage} />
        <ContentRoute path="/app/cart-price/new" component={CartPriceEdit} />
        <ContentRoute path="/app/cart-price/:id/edit" component={CartPriceEdit} />

        {/* wix categories */}
        <ContentRoute path="/wix-categories" component={WixCategoriesPage} />
        <ContentRoute path="/app/wix-categories/:id/:total/edit" component={WixCategoryEdit} />
        <ContentRoute path="/app/wix-categories/:id/view" component={CategoryViewDialog}/>

        {/* wocommerce categories */}
        <ContentRoute path="/woocommerce-categories" component={WocommCategoriesPage} />
        <ContentRoute path="/app/woocommerce-categories/:id/:total/edit" component={WocommCategoryEdit} />

         {/* activity categories */}
         <ContentRoute path="/activity" component={ActivityPage} />
       

        <Route path="/user-profile" component={UserProfilepage} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
